"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const loading_1 = __importDefault(require("../loading"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('progress_bar');
const ProgressBar = (props) => {
    const { data = [], value, style } = props;
    const [move, setMove] = React.useState(false);
    React.useEffect(() => {
        if (data.length > 1 && !move) {
            setTimeout(() => {
                setMove(true);
            }, 100);
        }
    }, [data]);
    let curIndex = -1;
    data.forEach((item, index) => {
        if (value === item.key) {
            curIndex = index;
        }
    });
    const moveX = data.length > 0 ? (100 / data.length) * (curIndex + 1) : 100;
    return (React.createElement(one_1.View, { className: prefixCls, style: style }, data === null || data === void 0 ? void 0 :
        data.map((item, index) => (React.createElement(one_1.View, { key: item.key, className: classnames_1.default({
                [`${prefixCls}-node`]: true,
                [`${prefixCls}-node_first`]: index === 0,
                [`${prefixCls}-node_last`]: index === curIndex,
                [`${prefixCls}-node_active`]: index <= curIndex,
            }) }, item.value))),
        data.length === 0 ? React.createElement(loading_1.default, { type: "gap", gapColor: "#E8E8E8" }) : null,
        React.createElement(one_1.View, { className: `${prefixCls}-process`, style: {
                width: move ? `${moveX}%` : 0,
                transition: `width ${(curIndex + 1) * 0.3}s ease-in`,
            } })));
};
exports.default = ProgressBar;
